import styled from "styled-components";

export const InputContainer = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
	position: relative;

	label {
		font-size: 14px;
		color: #000;
		line-height: 23px;
		margin-bottom: 0;
	}
`;

export const SearchContainer = styled.div`
	position: relative;
	width: 100%;

	input {
		padding: 8px 16px;
		border: 1px solid #31475a;
		border-radius: 4px;
		width: 100%;
		box-sizing: border-box;

		font-size: 14px;
		line-height: 23px;

		&::placeholder {
			color: #6c757d;
		}

		&:disabled {
			background-color: #e5e7eb;
			color: #31475a;
		}

		&:focus {
			outline: none;
		}
	}
`;

export const Dropdown = styled.div`
	position: absolute;
	top: 100%;
	left: 0;
	right: 0;
	background: white;
	border: 1px solid #31475a;
	border-top: none;
	border-radius: 0 0 4px 4px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
	z-index: 1000;
	max-height: 200px;
	overflow-y: auto;
`;

export const DropdownItem = styled.div`
	padding: 8px 16px;
	cursor: pointer;
	font-size: 14px;
	line-height: 23px;

	&:hover {
		background-color: #f8f9fa;
	}

	&:last-child {
		border-radius: 0 0 4px 4px;
	}
`;
